export enum MilestonesMode {
  ALL = 'ALL',
  EMEA = 'EMEA',
  AUS = 'AUS',
  LAS = 'LAS',
  BR = 'BR',
}
